const initialHeaders = () => ({
            ContentSource: "web",
            Authorization: localStorage.getItem("token") || "",
        }
    )
;

export default initialHeaders